module.exports = __webpack_public_path__ + "media/images/regions_old/Zinder-6a328cf2d8ffd2fc3c74f3cdb5f5893b.png";